import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToPetChangeRequest,
  mapPetChangeRequestFieldValuesPayload,
  type PetChangeRequest,
  type PetChangeRequestApiResource,
  type PetChangeRequestFieldValues,
} from './petChangeRequestsApi.types';

export async function fetchOwnPetChangeRequests(
  patientId: string,
  status: string,
  page: number,
  pageSize: number
): Promise<PaginatedResult<PetChangeRequest>> {
  const response = await httpClient.get<PaginatedApiResource<PetChangeRequestApiResource>>(
    '/me/pet-change-requests',
    {
      params: {
        patient_id: patientId.length === 0 ? undefined : patientId,
        status: status.length === 0 ? undefined : status,
        page,
        page_size: pageSize,
      },
    }
  );
  return mapPaginatedResource(response.data, mapApiResourceToPetChangeRequest);
}

export async function createPetChangeRequest(
  patientId: string,
  changes: PetChangeRequestFieldValues
): Promise<PetChangeRequest> {
  const response = await httpClient.post<PetChangeRequestApiResource>('/me/pet-change-requests', {
    patient_id: patientId,
    changes: mapPetChangeRequestFieldValuesPayload(changes),
  });
  return mapApiResourceToPetChangeRequest(response.data);
}

export async function cancelOwnPetChangeRequest(requestId: string): Promise<PetChangeRequest> {
  const response = await httpClient.post<PetChangeRequestApiResource>(
    '/me/pet-change-requests/' + requestId + '/cancel'
  );
  return mapApiResourceToPetChangeRequest(response.data);
}

export async function fetchWorkspacePetChangeRequests(
  patientId: string,
  status: string,
  page: number,
  pageSize: number
): Promise<PaginatedResult<PetChangeRequest>> {
  const response = await httpClient.get<PaginatedApiResource<PetChangeRequestApiResource>>(
    '/pet-change-requests',
    {
      params: {
        patient_id: patientId.length === 0 ? undefined : patientId,
        status: status.length === 0 ? undefined : status,
        page,
        page_size: pageSize,
      },
    }
  );
  return mapPaginatedResource(response.data, mapApiResourceToPetChangeRequest);
}

export async function approvePetChangeRequest(requestId: string): Promise<PetChangeRequest> {
  const response = await httpClient.post<PetChangeRequestApiResource>(
    '/pet-change-requests/' + requestId + '/approve'
  );
  return mapApiResourceToPetChangeRequest(response.data);
}

export async function rejectPetChangeRequest(
  requestId: string,
  reviewNote: string
): Promise<PetChangeRequest> {
  const response = await httpClient.post<PetChangeRequestApiResource>(
    '/pet-change-requests/' + requestId + '/reject',
    { review_note: reviewNote }
  );
  return mapApiResourceToPetChangeRequest(response.data);
}
